import {useState} from 'react'
import { makeStyles } from '@material-ui/styles';
import {
    Accordion, AccordionSummary, Typography, Divider, 
    AccordionDetails, AccordionActions, Button
} from '@material-ui/core';

import { 
    ExpandMore as ExpandMoreIcon, FilterList as FilterListIcon,
    Clear as ClearIcon, Add as AddIcon 
} from '@material-ui/icons'

const useStyles = makeStyles({
    fullPage: {
        width: '100%',
        padding: '10px 10px 5px 10px'
    },
    titlePage:{
        padding: '0 0 5px 10px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    }
})

function Container({ title, children, buttonsRight }) {
    const classes = useStyles();

    return (
        <div className={classes.fullPage}>
            <div className={classes.titlePage}>
                <Typography style={{marginTop: 5}}>
                    { title }
                </Typography>
                <div>
                    { buttonsRight && buttonsRight.map( (buttons, index) => (
                        <Button className={classes.buttons} style={{...buttons.style}} disabled={buttons.disabled} color={buttons.color} onClick={() => buttons.onClick()} key={index}>
                            {buttons.icon}&nbsp;{buttons.title}
                        </Button>
                    ))}
                </div>
            </div>
            { children }
        </div>
    )
}

export default Container
